import { type MCPServerInfo } from '../../types';

const AwsCloudWatchServer: MCPServerInfo = {
  serverId: 'AWS_CLOUDWATCH',
  name: 'AWS CloudWatch',
  slug: 'aws-cloudwatch',
  description:
    'AWS CloudWatch MCP Server. Query metrics, analyze alarms, and search logs using CloudWatch Logs Insights directly from your AI assistant.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'public.ecr.aws/awslabs-mcp/awslabs/cloudwatch-mcp-server:sha-d1b4395214a701efdc243099c84b2abde382c463',
    commitSha: 'd1b4395',
    packageType: 'pip',
    packageName: 'awslabs.cloudwatch-mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'awsAccessKeyId',
      'awsRegion',
      'awsSecretAccessKey',
      'awsSessionToken'
    ],
    properties: {
      awsAccessKeyId: {
        type: 'string',
        description: 'AWS Access Key ID',
        sensitive: true
      },
      awsRegion: {
        type: 'string',
        description: 'AWS region (e.g. us-east-1)',
        sensitive: false
      },
      awsSecretAccessKey: {
        type: 'string',
        description: 'AWS Secret Access Key',
        sensitive: true
      },
      awsSessionToken: {
        type: 'string',
        description: 'AWS Session Token',
        sensitive: true
      },
      fastmcpLogLevel: {
        type: 'string',
        description: 'FastmcpLogLevel',
        sensitive: false,
        default: 'ERROR'
      }
    }
  }
};

export default AwsCloudWatchServer;
